import { inject } from 'vue'
import { HTTP_PLUGIN_KEY } from '@/plugins/http.ts'
import type { AxiosInstance } from 'axios'

export const useHttp = (): AxiosInstance => {
  const http = inject<AxiosInstance>(HTTP_PLUGIN_KEY)

  if (!http) {
    throw new Error('Could not resolve HTTP instance')
  }

  return http
}